import { successColor } from "./status/success.js";
const success = (mode)=>{
    const color = successColor(mode);
    return {
        main: color.main,
        light: 'light' === mode ? color.lowContrast : color.highContrast,
        dark: 'light' === mode ? color.highContrast : color.lowContrast
    };
};
export { success };

//# sourceMappingURL=success.js.map